import React from 'react';
import { useI18n } from '../i18n/I18nContext';

/** I collegamenti alle previsioni esterne dello stesso punto (sito in elenco o punto toccato). */
export const ExternalLinks: React.FC<{ lat: number; lng: number }> = ({ lat, lng }) => {
  const { t } = useI18n();
  return (
    <div className="external-links-section">
      <a
        href={`https://www.windy.com/${lat}/${lng}/airgram?${lat},${lng},11`}
        target="_blank"
        rel="noopener noreferrer"
        className="external-forecast-link"
        title={t('ui.openWindy')}
      >
        <img src="/windy_logo.png" alt="Windy" className="forecast-link-logo" />
        <span className="forecast-link-text">Windy Airgram</span>
        <img src="/external_link_icon.svg" alt={t('ui.externalLink')} width="16" height="16" className="external-link-icon" />
      </a>
      <a
        href={`https://meteo-parapente.com/#/${lat},${lng},11`}
        target="_blank"
        rel="noopener noreferrer"
        className="external-forecast-link"
        title={t('ui.openMeteoParapente')}
      >
        <img src="/meteo_parapente_logo.png" alt="Meteo-Parapente" className="forecast-link-logo meteo-logo" />
        <span className="forecast-link-text">Meteo-Parapente</span>
        <img src="/external_link_icon.svg" alt={t('ui.externalLink')} width="16" height="16" className="external-link-icon" />
      </a>
    </div>
  );
};
